import { useScrollProgress } from "../../hooks/useInteractions";

/** Thin cyan scroll progress bar at the top of the viewport */
export const ScrollProgress = () => {
  const p = useScrollProgress();
  return (
    <div
      aria-hidden
      className="fixed top-0 left-0 right-0 h-[2px] z-[60] pointer-events-none"
    >
      <div
        className="h-full origin-left bg-gradient-to-r from-cyan-400 via-cyan-300 to-blue-500"
        style={{
          transform: `scaleX(${p})`,
          boxShadow: "0 0 12px rgba(0,229,255,0.6)",
          transition: "transform 80ms linear",
        }}
      />
    </div>
  );
};

export default ScrollProgress;
